(function () {
  const DURATION_OPEN = 280;
  const DURATION_CLOSE = 220;
  const EASING = 'cubic-bezier(0.22, 1, 0.36, 1)';

  function setupAnimatedDetails(details) {
    if (details.dataset.faqAnimated === 'true') return;
    details.dataset.faqAnimated = 'true';

    const summary = details.querySelector('summary');
    const content = details.querySelector('.iurop-faq__answer');
    if (!summary || !content) return;

    let animation = null;
    let isClosing = false;
    let isExpanding = false;

    summary.addEventListener('click', (event) => {
      event.preventDefault();
      details.style.overflow = 'hidden';

      if (isClosing || !details.open) {
        details.classList.add('is-open');
        open();
      } else if (isExpanding || details.open) {
        details.classList.remove('is-open');
        shrink();
      }
    });

    function open() {
      details.style.height = `${details.offsetHeight}px`;
      details.open = true;
      window.requestAnimationFrame(expand);
    }

    function expand() {
      isExpanding = true;
      const startHeight = `${details.offsetHeight}px`;
      const endHeight = `${summary.offsetHeight + content.offsetHeight}px`;

      if (animation) animation.cancel();

      animation = details.animate(
        { height: [startHeight, endHeight] },
        { duration: DURATION_OPEN, easing: EASING }
      );

      animation.onfinish = () => onFinish(true);
      animation.oncancel = () => {
        isExpanding = false;
      };
    }

    function shrink() {
      isClosing = true;
      const startHeight = `${details.offsetHeight}px`;
      const endHeight = `${summary.offsetHeight}px`;

      if (animation) animation.cancel();

      animation = details.animate(
        { height: [startHeight, endHeight] },
        { duration: DURATION_CLOSE, easing: EASING }
      );

      animation.onfinish = () => onFinish(false);
      animation.oncancel = () => {
        isClosing = false;
      };
    }

    function onFinish(open) {
      details.open = open;
      animation = null;
      isClosing = false;
      isExpanding = false;
      details.style.height = '';
      details.style.overflow = '';
    }
  }

  function initFaq(section) {
    const tabs = section.querySelectorAll('[data-faq-tab]');
    const items = section.querySelectorAll('[data-faq-category]');

    items.forEach(setupAnimatedDetails);

    if (tabs.length === 0) return;

    tabs.forEach((tab) => {
      tab.addEventListener('click', () => {
        const target = tab.getAttribute('data-faq-tab');

        tabs.forEach((t) => {
          const isActive = t === tab;
          t.classList.toggle('is-active', isActive);
          t.setAttribute('aria-selected', isActive ? 'true' : 'false');
        });

        items.forEach((item) => {
          const cat = item.getAttribute('data-faq-category') || '';
          const matches = target === 'all' || cat === target;
          item.hidden = !matches;
          if (!matches) {
            item.removeAttribute('open');
            item.classList.remove('is-open');
          }
        });
      });
    });
  }

  function init() {
    document.querySelectorAll('[data-iurop-faq]').forEach(initFaq);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }

  document.addEventListener('shopify:section:load', (event) => {
    const section = event.target.querySelector('[data-iurop-faq]');
    if (section) initFaq(section);
  });
})();
